import {INotification} from 'src/utils/declarations';
import {NotificationActions, NotificationActionTypes} from '../actions';

export interface INotificationsWindowInfo {
  data: INotification[];
  count: number;
  addedNewNotification: boolean;
}

export interface INotificationsContainerInfo {
  data: INotification[];
  loading: boolean;
  total: number;
}

export interface State {
  // data for notifications window in header
  window: INotificationsWindowInfo;
  // data for notifications page
  container: INotificationsContainerInfo;
}

export const initialState: State = {
  window: {
    data: [],
    count: 0,
    addedNewNotification: false,
  },
  container: {
    data: [],
    loading: false,
    total: 0,
  },
};

export function reducer(
  state: State = initialState,
  action: NotificationActions
): State {
  switch (action.type) {
    case NotificationActionTypes.GET_DATA_IN_WINDOW_SUCCESS: {
      const {data, meta} = action.payload;
      return {
        ...state,
        window: {
          data: data ? data : [],
          count: meta ? meta.total < data.length ? meta.total : data.length : 0,
          addedNewNotification: false,
        },
      };
    }

    case NotificationActionTypes.GET_DATA_IN_CONTAINER: {
      return {
        ...state,
        container: {
          ...state.container,
          loading: true,
        },
      };
    }

    case NotificationActionTypes.GET_DATA_IN_CONTAINER_SUCCESS: {
      const {data, meta} = action.payload;
      return {
        ...state,
        container: {
          data: data,
          loading: false,
          total: meta.total,
        },
      };
    }

    case NotificationActionTypes.CREATE_SUCCESS: {
      return {
        ...state,
        window: {
          ...state.window,
          count: state.window.count + 1,
          addedNewNotification: true,
        },
      };
    }

    case NotificationActionTypes.READ_ALL_SUCCESS: {
      const {ids} = action.payload;
      return {
        window: {
          ...state.window,
          data: [],
          count: 0,
        },
        container: {
          ...state.container,
          data: state.container.data.map((n) => {
            if (ids.includes(n.id)) {
              return {...n, read: true};
            }
            return n;
          }),
        },
      };
    }

    case NotificationActionTypes.READ_ONE_NOTIFICATION_SUCCESS: {
      const {id} = action.payload;
      const notificationIsInWindow = state.window.data.find((n) => n.id === id);

      if (notificationIsInWindow) {
        return {
          window: {
            ...state.window,
            data: state.window.data.filter((n) => n.id !== id),
            count: state.window.count - 1,
          },
          container: {
            ...state.container,
            // change object in response array
            data: state.container.data.map((n) => {
              if (n.id === id) {
                return {...n, read: true};
              }
              return n;
            }),
          },
        };
      }

      return {
        ...state,
        container: {
          ...state.container,
          // change object in response array
          data: state.container.data.map((n) => {
            if (n.id === id) {
              return {...n, read: true};
            }
            return n;
          }),
        },
      };
    }

    default: {
      return state;
    }
  }
}

export const getNotificationState = (state: State) => state;
export const getWindowInfo = (state: State) => state.window;
export const getContainerInfo = (state: State) => state.container;
export const getCount = (state: State) => state.window.count;
